var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKiFooterWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76.486,
    height: 71.624,
    viewBox: "0 0 76.486 71.624",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#ffffff}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_329",
    transform: "translate(-1733.543 -861.337)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5",
    d: "M1784.145 876.492a7.578 7.578 0 1 0-7.576-7.578 7.587 7.587 0 0 0 7.576 7.578z",
    className: "cls-1",
    transform: "translate(18.305 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6",
    d: "M1784.145 876.6a7.586 7.586 0 0 0-7.576 7.579v34.709a7.578 7.578 0 1 0 15.155 0V884.18a7.587 7.587 0 0 0-7.579-7.58z",
    className: "cls-1",
    transform: "translate(18.305 6.494)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7",
    d: "M1776.109 906.967l-11.5-11.806-.007.007c-.048-.053-.091-.108-.141-.16a7.575 7.575 0 0 0-11.262 10.116l.059.061c.114.134.227.269.351.4s.235.221.355.329l11.294 11.636.014-.013a7.568 7.568 0 0 0 10.829-10.56z",
    className: "cls-1",
    transform: "translate(7.621 13.351)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8",
    d: "M1778.129 876.142a7.568 7.568 0 0 0-3.933 1.107l-1.435.875-24.06 14.652v-23.861a7.578 7.578 0 0 0-15.157 0v56.469a7.578 7.578 0 0 0 15.157 0v-14.86l18.234-11.106 1.384-.842 12.326-7.506 1.435-.875a7.579 7.579 0 0 0-3.95-14.052z",
    className: "cls-1",
    transform: "translate(0 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKiFooterWhite);
export default __webpack_public_path__ + "static/media/ki-footer-white.6b77d4de4e536a19af69af5ae25f9edb.svg";
export { ForwardRef as ReactComponent };